import { render, staticRenderFns } from "./DiagnosticsList.vue?vue&type=template&id=4a49eec4&scoped=true"
import script from "./DiagnosticsList.vue?vue&type=script&lang=ts"
export * from "./DiagnosticsList.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosticsList.vue?vue&type=style&index=0&id=4a49eec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49eec4",
  null
  
)

export default component.exports